export enum ConnectionStatusState {
    Online = 'ONLINE',
    Offline = 'OFFLINE',
}

export class ConnectionStatus {

    current: ConnectionStatusState | null = $state(null);

    init() {
        if (navigator.onLine) {
            this.current = ConnectionStatusState.Online
        } else {
            this.current = ConnectionStatusState.Offline
        }

        window.addEventListener('online', () => {
            this.current = ConnectionStatusState.Online
        });

        window.addEventListener('offline', () => {
            this.current = ConnectionStatusState.Offline
        })

    }

}